export default {
  'common.welcome': 'Welcome',
  'common.logout': 'Logout',
  'common.settings': 'Settings',
  'common.language': 'Language',
  'common.loading': 'Loading...',
  'common.error': 'Error',
  'common.retry': 'Retry',
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.save': 'Save',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.search': 'Search',
  'common.noData': 'No data available',
  'common.goHome': 'Go to Home',
  'common.goBack': 'Go Back',
  'common.success': 'Success',
  'common.warning': 'Warning',
  'common.info': 'Information',
  'common.operationSuccess': 'Operation completed successfully',
  'common.operationError': 'An error occurred',
};
